export default {
  "authFailed": "Incapace di terminare la configurazione del portale",
  "authFailureHelp": "Non potevamo ripristinare la sessione del club sicuro. Si prega di riprovare o firmare di nuovo.",
  "signInAgain": "Firma di nuovo",
  "retry": "Riprova",
  "restoringAuth": "Ripristino dell'autenticazione...",
  "resolvingOrg": "Risolvere l'organizzazione...",
  "loadingIdentity": "Caricamento dell'identità...",
  "checkingClub": "Controllare i dettagli del club...",
  "clubNotFound": "Club non trovato",
  "invalidLink": "Il link che hai seguito è invalido.",
  "verifyFailed": "Incapace di verificare la sessione",
  "verifyHelp": "Privana non ha potuto confermare la tua sessione di Auth0 esistenti. Si prega di firmare di nuovo per continuare.",
  "signIn": "Accedi",
  "close": "Chiudi",
  "broadcastResult": "SMS inviato: {sent} . Non riuscito: {failed} . Abilitato: {skipped} .",
  "activeScope": "I giocatori attivi attualmente in campo: {count} .",
  "inherit": "Lingua del club",
  "saveFailed": "Non è possibile salvare la lingua. Si prega di riprovare."
};
